export default {
  title_one: 'Delivery stats updating for "{{title}}"',
  title_other: 'Delivery stats updating for {{count}} campaigns',
  subtitle_pending:
    'Apple and Google confirm receipts in about {{minutes}}m {{seconds}}s (around {{time}}). The stats will refresh automatically.',
  subtitle_ready: 'Receipts should be in. Refresh the page to see the latest delivery numbers.',
};
